import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export interface IMediaPermissionsState {
  camera: boolean
  microphone: boolean
}

export const initialMediaPermissionsState: IMediaPermissionsState = {
  camera: true,
  microphone: true,
}

const mediaPermissionsAdapter = createEntityAdapter()

export const mediaPermissionsSlice = createSlice({
  name: 'mediaPermissions',
  initialState: mediaPermissionsAdapter.getInitialState(initialMediaPermissionsState),
  reducers: {
    setMediaPermissions: (state, action: PayloadAction<IMediaPermissionsState>) => {
      state.camera = action.payload?.camera
      state.microphone = action.payload?.microphone
    },
    setCameraPermission: (state, action: PayloadAction<boolean>) => {
      state.camera = action.payload
    },
    setMicrophonePermission: (state, action: PayloadAction<boolean>) => {
      state.microphone = action.payload
    },
  },
})

export const { setMediaPermissions, setCameraPermission, setMicrophonePermission } =
  mediaPermissionsSlice.actions

export const { selectAll: mediaPermissionsSelector } = mediaPermissionsAdapter.getSelectors(
  (state: RootState) => state[mediaPermissionsSlice.name],
)

export const selectMediaPermissions = (state: RootState) => state.mediaPermissions
